import React from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { apiPost } from '../../api/client';
import '../../styles/admin.css';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: 'fas fa-home', end: true },
  { to: '/admin/catalog', label: 'Tool Catalog', icon: 'fas fa-store' },
  { to: '/admin/tool-pages', label: 'Tool Pages', icon: 'fas fa-file-alt' },
  { to: '/admin/stream-pages', label: 'Stream Pages', icon: 'fas fa-broadcast-tower' },
  { to: '/admin/reviews', label: 'Reviews', icon: 'fas fa-star' },
  { to: '/admin/pages', label: 'Pages', icon: 'fas fa-columns' },
  { to: '/admin/schedule', label: 'Schedule Games', icon: 'fas fa-calendar' },
  { to: '/admin/streamers', label: 'Streamers', icon: 'fab fa-twitch' },
  { to: '/admin/media', label: 'Media', icon: 'fas fa-images' },
  { to: '/admin/settings', label: 'Settings', icon: 'fas fa-cog' },
];

const TITLES = {
  '/admin': 'Dashboard',
  '/admin/catalog': 'Tool Catalog',
  '/admin/tool-pages': 'Tool Pages',
  '/admin/stream-pages': 'Stream Pages',
  '/admin/reviews': 'Game Reviews',
  '/admin/pages': 'Site Pages',
  '/admin/schedule': 'Schedule Games',
  '/admin/streamers': 'Featured Streamers',
  '/admin/media': 'Media Library',
  '/admin/settings': 'Settings',
};

export default function AdminLayout() {
  const location = useLocation();
  const title = TITLES[location.pathname] || 'ZeMaxi CMS';

  const handleLogout = async () => {
    await apiPost('/admin/logout');
    window.location.href = '/admin/login';
  };

  return (
    <div className="admin-page">
      <div className="admin-shell">
        <aside className="admin-sidebar">
          <div className="admin-brand">ZeMaxi <span>CMS</span></div>
          <nav className="admin-sidebar-nav">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end}>
                <i className={item.icon} aria-hidden="true" />
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="admin-sidebar-footer">
            <Link to="/"><i className="fas fa-external-link-alt"></i> View Site</Link>
            <button type="button" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt"></i> Logout
            </button>
          </div>
        </aside>
        <div className="admin-body">
          <div className="admin-topbar">
            <h2>{title}</h2>
            <p>Manage site content without rebuilding the React app.</p>
          </div>
          <div className="admin-main">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
